<div class="ns-tab-page">
  <section class="ns-tab-intro">
    <div class="ns-tab-toolbar">
      <h2>Templates</h2>
      <div class="ns-channel-tabs" role="tablist" aria-label="Template channel">
        <button
          type="button"
          *ngFor="let item of channels"
          [class.is-on]="activeChannel === item.key"
          (click)="setChannel(item.key)"
        >
          {{ item.label }}
        </button>
      </div>
      <button type="button" class="ns-save" [class.is-unauthorized]="!isWriteAllowed" (click)="openCreate()">
        New {{ channelLabel(activeChannel) }} template
      </button>
    </div>
    <p>
      Used by On Demand Request today. Other services can use these templates later.
    </p>
  </section>

  <p class="ns-banner ns-banner--error" *ngIf="loadError">
    {{ loadError }}
    <button type="button" class="ns-link-btn" (click)="load()">Retry</button>
  </p>

  <div class="ns-tpl-loader" *ngIf="loading">
    <app-ltms-loader></app-ltms-loader>
  </div>

  <div class="version-history-container" *ngIf="!loading && !loadError">
    <div class="search-pagination-container">
      <div class="drafts-header">
        <h3>{{ channelLabel(activeChannel) }} templates</h3>
      </div>
      <div class="pagination-controls">
        <ng-container *ngIf="totalCount > 0">
          <button type="button" (click)="goToFirstPage()" [disabled]="!hasPrevPage">
            <img src="assets/images/chevron-double-left.svg" alt="First">
          </button>
          <button type="button" (click)="pageMove('previous')" [disabled]="!hasPrevPage">
            <img src="assets/images/chevron-left.svg" alt="Previous">
          </button>
          <div class="pagination-text">
            {{ rangeStart }} - {{ rangeEnd }} of {{ totalCount }}
          </div>
          <button type="button" (click)="pageMove('next')" [disabled]="!hasNextPage">
            <img src="assets/images/chevron-right.svg" alt="Next">
          </button>
          <button type="button" (click)="goToLastPage()" [disabled]="!hasNextPage">
            <img src="assets/images/chevron-double-right.svg" alt="Last">
          </button>
        </ng-container>
      </div>
    </div>

    <div class="table-responsive version-table" *ngIf="pagedRows.length">
      <table>
        <thead>
          <tr>
            <th>Title</th>
            <th>Used for</th>
            <th>Language</th>
            <th>Created On</th>
            <th>Created By</th>
            <th>Status</th>
            <th class="action-header-cell">Actions</th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let row of pagedRows">
            <td>
              <div class="ns-id-cell">
                <span class="ns-text" [title]="displayTitle(row)">{{ displayTitle(row) }}</span>
                <button
                  type="button"
                  class="ns-copy"
                  *ngIf="row.template_name"
                  title="Copy template name"
                  aria-label="Copy template name"
                  (click)="copyTemplateId(row.template_name, $event, 'Template name')"
                >
                  <i class="fa fa-copy"></i>
                </button>
              </div>
            </td>
            <td>
              <span class="ns-text" [title]="usedForLabel(row.template_used_for)">{{ usedForLabel(row.template_used_for) }}</span>
            </td>
            <td>{{ row.template_language }}</td>
            <td class="ns-nowrap">{{ createdOn(row) ? (createdOn(row) | date: 'dd-MMM-yy, HH:mm') : '—' }}</td>
            <td>
              <span class="ns-text" [title]="createdByTitle(row)">{{ createdBy(row) }}</span>
            </td>
            <td>
              <span class="status-tag" [class.live-tag]="row.is_active" [class.draft-tag]="!row.is_active">
                {{ row.is_active ? 'Active' : 'Inactive' }}
              </span>
            </td>
            <td class="action-column-cell">
              <div class="ns-row-actions">
                <div class="ns-email-actions" *ngIf="activeChannel === 'email'">
                  <button type="button" class="ns-save ns-save--sm ns-save--ghost" (click)="viewEmailHtml(row)">View</button>
                  <button type="button" class="ns-save ns-save--sm ns-save--ghost" (click)="previewEmailHtml(row)">Preview</button>
                  <button type="button" class="ns-save ns-save--sm ns-save--ghost" (click)="downloadEmailHtml(row)">Download</button>
                </div>
                <button
                  type="button"
                  class="ns-icon-btn"
                  [title]="editTip()"
                  [attr.aria-label]="editTip()"
                  (click)="openEdit(row)"
                >
                  <i class="fa" [class.fa-pencil]="isWriteAllowed" [class.fa-eye]="!isWriteAllowed" aria-hidden="true"></i>
                </button>
                <button
                  type="button"
                  class="ns-icon-btn ns-icon-btn--danger"
                  [class.is-unauthorized]="!isWriteAllowed"
                  [class.is-in-use]="isTemplateInUse(row)"
                  [title]="deleteTip(row)"
                  [attr.aria-label]="deleteTip(row)"
                  (click)="askDelete(row)"
                >
                  <i class="fa fa-trash" aria-hidden="true"></i>
                </button>
              </div>
            </td>
          </tr>
        </tbody>
      </table>
    </div>

    <div class="no-data-container" *ngIf="!pagedRows.length">
      <p class="no-data-message">No {{ channelLabel(activeChannel) }} templates yet.</p>
    </div>
  </div>
</div>

<div class="ns-drawer" *ngIf="editorOpen">
  <div class="ns-drawer__overlay" (click)="closeEditor()"></div>
  <aside class="ns-drawer__panel" role="dialog" aria-modal="true">
    <header class="ns-panel__head">
      <div>
        <h2>{{ form.id ? 'Edit' : 'New' }} {{ channelLabel(activeChannel) }} template</h2>
        <p>Used by On Demand Request today.</p>
      </div>
      <button type="button" class="ns-panel__close" (click)="closeEditor()" aria-label="Close">×</button>
    </header>
    <div class="ns-panel__body">
      <label [class.is-invalid]="hasError('template_title')" [class.is-dirty]="!hasError('template_title') && isFormDirty('template_title')">
        <span class="ns-label">Title <span class="ns-req">*</span></span>
        <input
          type="text"
          [(ngModel)]="form.template_title"
          [disabled]="!isWriteAllowed"
          [maxlength]="fieldMax.title"
          (ngModelChange)="onFieldChange()"
        />
      </label>
      <p class="ns-field-error" *ngIf="fieldError('template_title')">{{ fieldError('template_title') }}</p>

      <label
        [class.is-invalid]="hasError('template_used_for')"
        [class.is-dirty]="!hasError('template_used_for') && isFormDirty('template_used_for')"
        [attr.title]="lockTip('usedFor')"
      >
        <span class="ns-label">Template used for <span class="ns-req">*</span></span>
        <select
          [(ngModel)]="form.template_used_for"
          [disabled]="!isWriteAllowed || !!form.id"
          (ngModelChange)="onFieldChange()"
        >
          <option *ngFor="let item of usedForOptions" [value]="item.key">{{ item.label }}</option>
        </select>
      </label>
      <p class="ns-help">{{ usedForHint }}</p>
      <p class="ns-field-error" *ngIf="fieldError('template_used_for')">{{ fieldError('template_used_for') }}</p>

      <div class="ns-row">
        <label
          [class.is-invalid]="hasError('template_language')"
          [class.is-dirty]="!hasError('template_language') && isFormDirty('template_language')"
          [attr.title]="lockTip('language')"
        >
          <span class="ns-label">Language <span class="ns-req">*</span></span>
          <select [(ngModel)]="form.template_language" [disabled]="!isWriteAllowed || !!form.id" (ngModelChange)="onFieldChange()">
            <option value="">Select language</option>
            <option *ngFor="let lang of languageChoices()" [value]="lang.key">{{ lang.name }} ({{ lang.native_name }})</option>
          </select>
        </label>
        <label class="ns-switch" [class.is-dirty]="isFormDirty('is_active')" [attr.title]="lockTip('active')">
          <input
            type="checkbox"
            [ngModel]="form.is_active"
            [disabled]="!isWriteAllowed || (templateInUse && form.is_active)"
            (ngModelChange)="setActive($event)"
          />
          Active
        </label>
      </div>
      <p class="ns-help" *ngIf="form.id && templateUsageChecked && templateInUse">This template is used in channel setup, so it stays active.</p>
      <p class="ns-help" *ngIf="form.id && templateUsageChecked && !templateInUse">This template is not used in channel setup.</p>
      <p class="ns-field-error" *ngIf="fieldError('template_language')">{{ fieldError('template_language') }}</p>

      <ng-container *ngIf="activeChannel !== 'email'">
        <label [class.is-invalid]="hasError('template_id')" [class.is-dirty]="!hasError('template_id') && isFormDirty('template_id')">
          <span class="ns-label">Template Id <span class="ns-req">*</span></span>
          <div class="ns-id-field">
            <input
              type="text"
              [(ngModel)]="form.template_id"
              [disabled]="!isWriteAllowed"
              [maxlength]="fieldMax.id"
              (ngModelChange)="onFieldChange()"
            />
            <button
              type="button"
              class="ns-copy"
              *ngIf="form.template_id"
              title="Copy Template Id"
              aria-label="Copy Template Id"
              (click)="copyTemplateId(form.template_id, $event)"
            >
              <i class="fa fa-copy"></i>
            </button>
          </div>
        </label>
        <p class="ns-field-error" *ngIf="fieldError('template_id')">{{ fieldError('template_id') }}</p>

        <label [class.is-invalid]="hasError('sender_id')" [class.is-dirty]="!hasError('sender_id') && isFormDirty('sender_id')">
          <span class="ns-label">Sender Id <span class="ns-req">*</span></span>
          <input
            type="text"
            [(ngModel)]="form.sender_id"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.sender"
            (ngModelChange)="onFieldChange()"
          />
        </label>
        <p class="ns-field-error" *ngIf="fieldError('sender_id')">{{ fieldError('sender_id') }}</p>

        <label *ngIf="activeChannel === 'sms'" [class.is-invalid]="hasError('principal_entity_id')" [class.is-dirty]="!hasError('principal_entity_id') && isFormDirty('principal_entity_id')">
          <span class="ns-label">Principal entity Id</span>
          <input
            type="text"
            [(ngModel)]="form.principal_entity_id"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.entity"
            (ngModelChange)="onFieldChange()"
          />
        </label>
        <p class="ns-field-error" *ngIf="fieldError('principal_entity_id')">{{ fieldError('principal_entity_id') }}</p>

        <label class="ns-switch" *ngIf="activeChannel === 'sms'" [class.is-dirty]="isFormDirty('template_unicode')">
          <input type="checkbox" [(ngModel)]="form.template_unicode" [disabled]="!isWriteAllowed" />
          Unicode SMS
        </label>

        <label [class.is-invalid]="hasError('template_text')" [class.is-dirty]="!hasError('template_text') && isFormDirty('template_text')">
          <span class="ns-label">Template text <span class="ns-req">*</span></span>
          <textarea
            rows="6"
            [(ngModel)]="form.template_text"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.text"
            (ngModelChange)="onFieldChange()"
          ></textarea>
        </label>
        <p class="ns-field-error" *ngIf="fieldError('template_text')">{{ fieldError('template_text') }}</p>

        <div class="ns-tokens">
          <span *ngFor="let field of mergeFields" [class.is-unauthorized]="!isWriteAllowed" (click)="insertToken(field.token)">
            {{ field.label }}
            <code>{{ field.token }}</code>
          </span>
        </div>

        <label *ngIf="activeChannel === 'whatsapp'" [class.is-invalid]="hasError('template_image')" [class.is-dirty]="!hasError('template_image') && isFormDirty('template_image')">
          <span class="ns-label">Template image URL</span>
          <input
            type="text"
            [(ngModel)]="form.template_image"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.image"
            (ngModelChange)="onFieldChange()"
          />
        </label>
        <p class="ns-field-error" *ngIf="fieldError('template_image')">{{ fieldError('template_image') }}</p>
      </ng-container>

      <ng-container *ngIf="activeChannel === 'email'">
        <label [class.is-invalid]="hasError('email_subject')" [class.is-dirty]="!hasError('email_subject') && isFormDirty('email_subject')">
          <span class="ns-label">Email subject <span class="ns-req">*</span></span>
          <input
            type="text"
            [(ngModel)]="form.email_subject"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.subject"
            (ngModelChange)="onFieldChange()"
          />
        </label>
        <p class="ns-field-error" *ngIf="fieldError('email_subject')">{{ fieldError('email_subject') }}</p>

        <label [class.is-invalid]="hasError('email_from')" [class.is-dirty]="!hasError('email_from') && isFormDirty('email_from')">
          <span class="ns-label">From <span class="ns-req">*</span></span>
          <input
            type="text"
            [(ngModel)]="form.email_from"
            [disabled]="!isWriteAllowed"
            [maxlength]="fieldMax.from"
            placeholder="LitmusWorld &lt;feedback&#64;litmusworld.net&gt;"
            list="email-from-suggestions"
            (ngModelChange)="onFieldChange()"
          />
          <datalist id="email-from-suggestions">
            <option *ngFor="let from of fromSuggestions" [value]="from"></option>
          </datalist>
        </label>
        <div class="ns-from-suggestions" *ngIf="fromSuggestions.length && isWriteAllowed">
          <span>Used on this project</span>
          <button type="button" *ngFor="let from of fromSuggestions" (click)="useFromSuggestion(from)">{{ from }}</button>
        </div>
        <p class="ns-help">Enter the sender like this: LitmusWorld &lt;feedback&#64;litmusworld.net&gt;.</p>
        <p class="ns-field-error" *ngIf="fieldError('email_from')">{{ fieldError('email_from') }}</p>

        <div class="ns-html" [class.is-invalid]="hasError('html')" [class.is-dirty]="!hasError('html') && (isFormDirty('html') || isFormDirty('file_name'))">
          <span class="ns-label">HTML template <span class="ns-req" *ngIf="!form.id">*</span></span>
          <p class="ns-help" *ngIf="form.id && form.template_id && !form.html">
            HTML file is already attached. Upload a new file only if you want to replace it.
          </p>
          <p class="ns-help" *ngIf="!form.id && !form.html">Upload a .html file for this email template.</p>
          <p class="ns-help" *ngIf="form.file_name">{{ form.file_name }}</p>
          <input #htmlFile type="file" accept=".html,text/html" hidden (change)="onHtmlFile($event)" />
          <div class="ns-html-actions">
            <button
              type="button"
              class="ns-save ns-save--sm ns-save--ghost"
              [class.is-unauthorized]="!isWriteAllowed"
              (click)="pickHtmlFile(htmlFile)"
            >
              {{ form.file_name || (form.id ? 'Replace HTML' : 'Upload HTML') }}
            </button>
            <button type="button" class="ns-save ns-save--sm ns-save--ghost" [disabled]="!canReadEmailHtml()" (click)="viewEmailHtml()">View</button>
            <button type="button" class="ns-save ns-save--sm ns-save--ghost" [disabled]="!canReadEmailHtml()" (click)="previewEmailHtml()">Preview</button>
            <button type="button" class="ns-save ns-save--sm ns-save--ghost" [disabled]="!canReadEmailHtml()" (click)="downloadEmailHtml()">Download</button>
          </div>
          <p class="ns-field-error" *ngIf="fieldError('html')">{{ fieldError('html') }}</p>
        </div>
      </ng-container>

      <section class="ns-history" *ngIf="historyNewest.length">
        <span class="ns-used__label">Update history</span>
        <p class="ns-help">Last {{ historyNewest.length }} change{{ historyNewest.length === 1 ? '' : 's' }} on this template.</p>
        <ol>
          <li *ngFor="let entry of historyNewest">
            <strong>{{ entry.action || 'updated' }}</strong>
            <span>{{ entry.name || entry.email_address || 'Someone' }}</span>
            <em>{{ entry.updated_date | date: 'MMM d, y, h:mm a' }}</em>
          </li>
        </ol>
      </section>
    </div>
    <footer class="ns-panel__foot">
      <button
        type="button"
        class="ns-save ns-save--ghost"
        [disabled]="!formDirty || saving"
        (click)="discardChanges()"
      >
        Discard
      </button>
      <div class="ns-panel__foot-actions">
        <button type="button" class="ns-save ns-save--ghost" (click)="closeEditor()">Cancel</button>
        <button type="button" class="ns-save" [class.is-unauthorized]="!isWriteAllowed" [disabled]="isWriteAllowed && (!formDirty || saving)" (click)="save()">
          {{ saving ? 'Saving…' : 'Save template' }}
        </button>
      </div>
    </footer>
  </aside>
</div>

<div class="ns-confirm" *ngIf="confirmSave">
  <div class="ns-confirm__overlay" (click)="cancelSaveConfirm()"></div>
  <div class="ns-confirm__card">
    <h3>{{ confirmSave.title }}</h3>
    <p>{{ confirmSave.message }}</p>
    <div class="ns-confirm__actions">
      <button type="button" class="ns-save ns-save--ghost" (click)="cancelSaveConfirm()">Don't continue</button>
      <button type="button" class="ns-save" [disabled]="saving" (click)="confirmSaveNow()">Yes, continue</button>
    </div>
  </div>
</div>

<div class="ns-confirm" *ngIf="confirmDelete">
  <div class="ns-confirm__overlay" (click)="cancelDelete()"></div>
  <div class="ns-confirm__card">
    <h3>Delete this template?</h3>
    <p>
      {{ displayTitle(confirmDelete) }} will be removed from the library. Existing attempts that already selected it keep their copy until you change them.
    </p>
    <div class="ns-confirm__actions">
      <button type="button" class="ns-save ns-save--ghost" (click)="cancelDelete()">Don't continue</button>
      <button type="button" class="ns-save" (click)="confirmDeleteNow()">Yes, continue</button>
    </div>
  </div>
</div>

<div class="ns-drawer ns-drawer--preview" *ngIf="emailPreviewOpen">
  <div class="ns-drawer__overlay" (click)="closeEmailPreview()"></div>
  <aside class="ns-drawer__panel ns-drawer__panel--preview" role="dialog" aria-modal="true" aria-labelledby="ns-email-preview-title">
    <header class="ns-panel__head">
      <div>
        <h2 id="ns-email-preview-title">Email preview</h2>
        <p>Sample customer, not a live send.</p>
      </div>
      <button type="button" class="ns-panel__close" (click)="closeEmailPreview()" aria-label="Close preview">×</button>
    </header>
    <div class="ns-panel__body ns-inbox-wrap">
      <div class="ns-inbox">
        <div class="ns-inbox__head">
          <p class="ns-inbox__subject">{{ emailPreviewSubject || 'No subject' }}</p>
          <p class="ns-inbox__from">{{ emailPreviewFrom || 'From address not set' }}</p>
        </div>
        <iframe
          *ngIf="emailPreviewUrl"
          class="ns-mail__frame"
          [src]="emailPreviewUrl"
          sandbox="allow-popups allow-popups-to-escape-sandbox"
          title="Email preview"
        ></iframe>
      </div>
    </div>
  </aside>
</div>
